import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import SEO from "../common/SEO";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import seoData from "../seoData/MobileAppDevelopment.json"
// import argumentTeam from "../assets/image/services/argumentTeam.svg"
// import liIcon from "../li-icon.svg"

const MobileAppDevelopment = () => {
  return (
    <>
      <SEO {...seoData} />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne title="Mobile App Development" page="Mobile App Development" />

        <div className="section section-padding pb-0">
          <div className="container">
            <div className="row mb--40">
              <div className="col-lg-9">
                <h2 className="mb-3">Turn a business idea into an app people actually use</h2>
                <p className="mb-3">
                  A mobile app succeeds or fails on the details most companies
                  don't think about until it's too late — onboarding that
                  loses users on screen one, a slow first launch, a feature
                  list that tries to do everything and ends up doing nothing
                  particularly well. We build for full-stack app development,
                  from a first idea through to something live in the app
                  stores, with a hire process built for exactly that.
                </p>
                <p>
                  We design and develop Android and iOS applications from
                  scratch, and we handle the full process — architecture,
                  interface, backend, and the app-store submission itself —
                  rather than handing off half-finished pieces for you to
                  stitch together.
                </p>
              </div>
            </div>
            <section id="augmentation-card">
              <div className="py-4">
                <div className="section-header">
                  <h2 className="mb-3">Mobile app development, end to end</h2>
                  <p>
                    We provide complete custom mobile application development,
                    integration, and ongoing management services. Whether it's
                    a consumer-facing app or a transformative enterprise-level
                    solution, we manage the entire process — from concept to
                    delivery, and ongoing support after launch — delivering
                    solutions that work on Android, iOS, or both from a single
                    cross-platform codebase.
                  </p>
                  <p>
                    Building an app people actually want to use takes real
                    planning, not just development effort. We work with you
                    to scope a realistic budget and timeline upfront, then
                    build to that plan rather than letting scope drift as we
                    go. Bring your idea to us and we'll help shape it into a
                    product worth shipping.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-11 col-lg-9 mx-auto ms-lg-0">
                  <div className="augmentation-card">
                    <h3 className="augmentation-title num3">
                      1. Android App Development
                    </h3>
                    <p className="mb-0 mt-3">
                      Standing out among the millions of apps already on
                      Google Play takes more than a working feature set. Our
                      Android app development services are built around a UI
                      and UX that actually earns a second open — clear
                      navigation, fast load times, and a feature set scoped to
                      what your users need rather than everything we could
                      technically build.
                    </p>
                  </div>
                </div>
                <div className="col-11 col-lg-9 mt-4 mx-auto me-lg-4 ms-lg-auto">
                  <div className="augmentation-card">
                    <h3 className="augmentation-title num3">
                      2. iOS App Development
                    </h3>
                    <p className="mb-0 mt-3">
                      Our iOS development process is built around Apple's own
                      platform conventions and device range, so the app feels
                      native rather than ported over from somewhere else. We
                      cover every stage of the process, from initial ideation
                      and design through development, App Store review, and
                      launch.
                    </p>
                  </div>
                </div>
                <div className="col-11 col-lg-9 mt-4 mx-auto ms-lg-0">
                  <div className="augmentation-card">
                    <h3 className="augmentation-title num3">
                      3. React Native Cross-Platform App Development
                    </h3>
                    <p className="mb-0 mt-3">
                      When a single codebase for both Android and iOS makes
                      sense for your budget and timeline, React Native lets us
                      deliver that without a meaningful compromise on feel or
                      performance for most app types. It's a strong fit when
                      you need to reach both platforms without maintaining two
                      separate native teams and codebases long-term.
                    </p>
                  </div>
                </div>
                <div className="col-11 col-lg-9 mt-4 mx-auto me-lg-4 ms-lg-auto">
                  <div className="augmentation-card">
                    <h3 className="augmentation-title num3">
                      4. Flutter Cross-Platform App Development
                    </h3>
                    <p className="mb-0 mt-3">
                      Flutter is our other cross-platform option, and it tends
                      to shine when an app leans on custom UI and animation —
                      it renders its own interface rather than relying on
                      native platform components, which gives a native look
                      and feel with a high degree of design consistency across
                      both Android and iOS.
                    </p>
                  </div>
                </div>
                <div className="col-11 col-lg-9 mt-4 mx-auto ms-lg-0">
                  <div className="augmentation-card">
                    <h3 className="augmentation-title num3">
                      5. Mobile App Support &amp; Maintenance
                    </h3>
                    <p className="mb-0 mt-3">
                      Shipping the first version is not the end of the work.
                      We provide ongoing mobile app support and maintenance —
                      OS-version compatibility updates, bug fixes, performance
                      tuning, and small feature additions — so the app keeps
                      working reliably as both platforms and your own user
                      base evolve.
                    </p>
                  </div>
                </div>
                <div className="col-11 col-lg-9 mt-4 mx-auto me-lg-4 ms-lg-auto">
                  <div className="augmentation-card">
                    <h3 className="augmentation-title num3">
                      6. Mobile App Testing
                    </h3>
                    <p className="mb-0 mt-3">
                      We combine automated and manual testing across real
                      devices, not just simulators, so issues that only show
                      up on specific hardware or OS versions get caught before
                      users find them. That covers functional testing,
                      performance under real network conditions, and a
                      security review for anything handling personal or
                      payment data.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row mt--60">
                <div className="col-lg-9">
                  <h2 className="mb-3">How an app project moves from idea to launch</h2>
                  <p>
                    Every engagement starts with scoping — what the app needs
                    to do, who it's for, and which platforms actually matter
                    for your users, rather than building for every platform by
                    default. From there we move through wireframes and design,
                    development in short reviewable cycles, and testing on
                    real devices, so you're seeing working progress
                    throughout the build rather than a single reveal right
                    before launch. Once an app ships, we stay involved through
                    the support and maintenance phase covered above, since an
                    app's first release is rarely its last update.
                  </p>
                </div>
              </div>
            </section>
          </div>
          <ul className="list-unstyled shape-group-12">
            <li className="shape shape-1">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-2.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-2">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-3">
              <img
                src={process.env.PUBLIC_URL + "/images/others/circle-3.png"}
                alt="Circle"
              />
            </li>
          </ul>
        </div>

        <FooterOne parentClass="pt--150 pt_lg--100 pt_md--80 pt_sm--60" />
      </main>
    </>
  );
};

export default MobileAppDevelopment;
